import { join } from 'lodash'
import { IEdicionPregunta } from '../../../../model/candidato-api'

export class SubPregunta {
  p: IEdicionPregunta
  options: string[] = []
  eliminar: boolean = false

  editMainQ = false

  constructor(edp: IEdicionPregunta) {
    this.p = edp

    if (this.p.data.tipoq == 'SELECT') {
      this.options = this.p.data.options.split('|')
    }
  }

  paraGuardar() {
    // generar las opciones del select
    if (this.p.data.tipoq == 'SELECT') {
      this.p.data.options = join(this.options, '|')
    }

    if (this.eliminar) this.p.eliminar = true

    return this.p
  }

  paraEliminar() {
    this.eliminar = true
  }

  nuevaOpcion() {
    this.options.push('')
  }

  splitOpcion(idx: number) {
    this.options.splice(idx, 1)
  }

  toggleEditMainQ() {
    this.editMainQ = !this.editMainQ
  }
}
